module.exports = __webpack_public_path__ + "static/media/planner-l.f0469870.svg";